// extracted by mini-css-extract-plugin
module.exports = {"link":"Navigation_link__2mpHK","activeLink":"Navigation_activeLink__KsjL9"};